var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 506,
    viewBox: "0 0 115 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0609 191.94C23.0609 191.94 15.5564 171 23.0609 171C30.5655 171 23.0609 191.94 23.0609 191.94Z",
    fill: "#FFE900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.061 192.06C23.061 192.06 30.5656 213 23.061 213C15.4354 213 23.061 192.06 23.061 192.06Z",
    fill: "#FFE900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 191.939C23.0596 191.939 43.9997 184.435 43.9997 191.939C43.9997 199.444 23.0596 191.939 23.0596 191.939Z",
    fill: "#FFE900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9401 191.939C22.9401 191.939 2 199.444 2 191.939C2 184.435 22.9401 191.939 22.9401 191.939Z",
    fill: "#FFE900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 191.939C23.0596 191.939 32.5008 171.725 37.9476 177.051C43.2734 182.498 23.0596 191.939 23.0596 191.939Z",
    fill: "#FFE900"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0612 192.06C23.0612 192.06 13.6199 212.274 8.17309 206.948C2.72624 201.622 23.0612 192.06 23.0612 192.06Z",
    fill: "#FFE900"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 192.06C23.0596 192.06 43.2734 201.501 37.9476 206.948C32.6218 212.153 23.0596 192.06 23.0596 192.06Z",
    fill: "#FFE900"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0612 191.938C23.0612 191.938 2.84731 182.496 8.17312 177.049C13.4989 171.845 23.0612 191.938 23.0612 191.938Z",
    fill: "#FFE900"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0595 191.939C23.0595 191.939 7.80833 175.719 14.7077 172.693C21.607 169.667 23.0595 191.939 23.0595 191.939Z",
    fill: "#FAD300"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 192.06C23.0596 192.06 38.3107 208.28 31.4114 211.306C24.512 214.332 23.0596 192.06 23.0596 192.06Z",
    fill: "#FAD300"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 191.937C23.0596 191.937 39.279 176.686 42.3051 183.586C45.3311 190.606 23.0596 191.937 23.0596 191.937Z",
    fill: "#FAD300"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9398 192.06C22.9398 192.06 6.72032 207.311 3.69429 200.412C0.789306 193.392 22.9398 192.06 22.9398 192.06Z",
    fill: "#FAD300"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 191.938C23.0596 191.938 23.7858 169.667 30.8062 172.451C37.8265 175.235 23.0596 191.938 23.0596 191.938Z",
    fill: "#FAD300"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0615 192.06C23.0615 192.06 22.3352 214.332 15.3148 211.548C8.29445 208.764 23.0615 192.06 23.0615 192.06Z",
    fill: "#FAD300"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 192.06C23.0596 192.06 45.3311 192.786 42.5472 199.807C39.7632 206.706 23.0596 192.06 23.0596 192.06Z",
    fill: "#FAD300"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9403 191.938C22.9403 191.938 0.668795 191.212 3.45274 184.192C6.23669 177.292 22.9403 191.938 22.9403 191.938Z",
    fill: "#FAD300"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4502 191.94C26.4502 193.756 24.9977 195.329 23.0611 195.329C21.2455 195.329 19.6719 193.877 19.6719 191.94C19.6719 190.124 21.1244 188.551 23.0611 188.551C24.8767 188.551 26.4502 190.124 26.4502 191.94Z",
    fill: "#FAD300"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0609 400.94C21.0609 400.94 13.5564 380 21.0609 380C28.5655 380 21.0609 400.94 21.0609 400.94Z",
    fill: "#FFE900"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.061 401.06C21.061 401.06 28.5656 422 21.061 422C13.4354 422 21.061 401.06 21.061 401.06Z",
    fill: "#FFE900"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 400.939C21.0596 400.939 41.9997 393.435 41.9997 400.939C41.9997 408.444 21.0596 400.939 21.0596 400.939Z",
    fill: "#FFE900"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9401 400.939C20.9401 400.939 0 408.444 0 400.939C0 393.435 20.9401 400.939 20.9401 400.939Z",
    fill: "#FFE900"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 400.939C21.0596 400.939 30.5008 380.725 35.9476 386.051C41.2734 391.498 21.0596 400.939 21.0596 400.939Z",
    fill: "#FFE900"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0612 401.06C21.0612 401.06 11.6199 421.274 6.17309 415.948C0.726244 410.622 21.0612 401.06 21.0612 401.06Z",
    fill: "#FFE900"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 401.06C21.0596 401.06 41.2734 410.501 35.9476 415.948C30.6218 421.153 21.0596 401.06 21.0596 401.06Z",
    fill: "#FFE900"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0612 400.938C21.0612 400.938 0.847308 391.496 6.17312 386.049C11.4989 380.845 21.0612 400.938 21.0612 400.938Z",
    fill: "#FFE900"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0595 400.939C21.0595 400.939 5.80833 384.719 12.7077 381.693C19.607 378.667 21.0595 400.939 21.0595 400.939Z",
    fill: "#FAD300"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 401.06C21.0596 401.06 36.3107 417.28 29.4114 420.306C22.512 423.332 21.0596 401.06 21.0596 401.06Z",
    fill: "#FAD300"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 400.937C21.0596 400.937 37.279 385.686 40.3051 392.586C43.3311 399.606 21.0596 400.937 21.0596 400.937Z",
    fill: "#FAD300"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9398 401.06C20.9398 401.06 4.72032 416.311 1.69429 409.412C-1.21069 402.392 20.9398 401.06 20.9398 401.06Z",
    fill: "#FAD300"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 400.938C21.0596 400.938 21.7858 378.667 28.8062 381.451C35.8265 384.235 21.0596 400.938 21.0596 400.938Z",
    fill: "#FAD300"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0615 401.06C21.0615 401.06 20.3352 423.332 13.3148 420.548C6.29445 417.764 21.0615 401.06 21.0615 401.06Z",
    fill: "#FAD300"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 401.06C21.0596 401.06 43.3311 401.786 40.5472 408.807C37.7632 415.706 21.0596 401.06 21.0596 401.06Z",
    fill: "#FAD300"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9403 400.938C20.9403 400.938 -1.33121 400.212 1.45274 393.192C4.23669 386.292 20.9403 400.938 20.9403 400.938Z",
    fill: "#FAD300"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4502 400.94C24.4502 402.756 22.9977 404.329 21.0611 404.329C19.2455 404.329 17.6719 402.877 17.6719 400.94C17.6719 399.124 19.1244 397.551 21.0611 397.551C22.8767 397.551 24.4502 399.124 24.4502 400.94Z",
    fill: "#FAD300"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0609 233.94C23.0609 233.94 15.5564 213 23.0609 213C30.5655 213 23.0609 233.94 23.0609 233.94Z",
    fill: "#FFE900"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.061 234.06C23.061 234.06 30.5656 255 23.061 255C15.4354 255 23.061 234.06 23.061 234.06Z",
    fill: "#FFE900"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 233.939C23.0596 233.939 43.9997 226.435 43.9997 233.939C43.9997 241.444 23.0596 233.939 23.0596 233.939Z",
    fill: "#FFE900"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9401 233.939C22.9401 233.939 2 241.444 2 233.939C2 226.435 22.9401 233.939 22.9401 233.939Z",
    fill: "#FFE900"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 233.939C23.0596 233.939 32.5008 213.725 37.9476 219.051C43.2734 224.498 23.0596 233.939 23.0596 233.939Z",
    fill: "#FFE900"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0612 234.06C23.0612 234.06 13.6199 254.274 8.17309 248.948C2.72624 243.622 23.0612 234.06 23.0612 234.06Z",
    fill: "#FFE900"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 234.06C23.0596 234.06 43.2734 243.501 37.9476 248.948C32.6218 254.153 23.0596 234.06 23.0596 234.06Z",
    fill: "#FFE900"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0612 233.938C23.0612 233.938 2.84731 224.496 8.17312 219.049C13.4989 213.845 23.0612 233.938 23.0612 233.938Z",
    fill: "#FFE900"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0595 233.939C23.0595 233.939 7.80833 217.719 14.7077 214.693C21.607 211.667 23.0595 233.939 23.0595 233.939Z",
    fill: "#FAD300"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 234.06C23.0596 234.06 38.3107 250.28 31.4114 253.306C24.512 256.332 23.0596 234.06 23.0596 234.06Z",
    fill: "#FAD300"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 233.937C23.0596 233.937 39.279 218.686 42.3051 225.586C45.3311 232.606 23.0596 233.937 23.0596 233.937Z",
    fill: "#FAD300"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9398 234.06C22.9398 234.06 6.72032 249.311 3.69429 242.412C0.789306 235.392 22.9398 234.06 22.9398 234.06Z",
    fill: "#FAD300"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 233.938C23.0596 233.938 23.7858 211.667 30.8062 214.451C37.8265 217.235 23.0596 233.938 23.0596 233.938Z",
    fill: "#FAD300"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0615 234.06C23.0615 234.06 22.3352 256.332 15.3148 253.548C8.29445 250.764 23.0615 234.06 23.0615 234.06Z",
    fill: "#FAD300"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 234.06C23.0596 234.06 45.3311 234.786 42.5472 241.807C39.7632 248.706 23.0596 234.06 23.0596 234.06Z",
    fill: "#FAD300"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9403 233.938C22.9403 233.938 0.668795 233.212 3.45274 226.192C6.23669 219.292 22.9403 233.938 22.9403 233.938Z",
    fill: "#FAD300"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4502 233.94C26.4502 235.756 24.9977 237.329 23.0611 237.329C21.2455 237.329 19.6719 235.877 19.6719 233.94C19.6719 232.124 21.1244 230.551 23.0611 230.551C24.8767 230.551 26.4502 232.124 26.4502 233.94Z",
    fill: "#FAD300"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0609 64.9401C23.0609 64.9401 15.5564 44 23.0609 44C30.5655 44 23.0609 64.9401 23.0609 64.9401Z",
    fill: "#FFE900"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M23.061 65.0601C23.061 65.0601 30.5656 86.0001 23.061 86.0001C15.4354 86.0001 23.061 65.0601 23.061 65.0601Z",
    fill: "#FFE900"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 64.9394C23.0596 64.9394 43.9997 57.4348 43.9997 64.9394C43.9997 72.4439 23.0596 64.9394 23.0596 64.9394Z",
    fill: "#FFE900"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9401 64.9394C22.9401 64.9394 2 72.4439 2 64.9394C2 57.4348 22.9401 64.9394 22.9401 64.9394Z",
    fill: "#FFE900"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 64.9391C23.0596 64.9391 32.5008 44.7252 37.9476 50.051C43.2734 55.4979 23.0596 64.9391 23.0596 64.9391Z",
    fill: "#FFE900"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0612 65.0601C23.0612 65.0601 13.6199 85.2739 8.17309 79.9481C2.72624 74.6223 23.0612 65.0601 23.0612 65.0601Z",
    fill: "#FFE900"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 65.0601C23.0596 65.0601 43.2734 74.5012 37.9476 79.9481C32.6218 85.1528 23.0596 65.0601 23.0596 65.0601Z",
    fill: "#FFE900"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0612 64.9375C23.0612 64.9375 2.84731 55.4963 8.17312 50.0495C13.4989 44.8447 23.0612 64.9375 23.0612 64.9375Z",
    fill: "#FFE900"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0595 64.9388C23.0595 64.9388 7.80833 48.7193 14.7077 45.6933C21.607 42.6672 23.0595 64.9388 23.0595 64.9388Z",
    fill: "#FAD300"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 65.0601C23.0596 65.0601 38.3107 81.2795 31.4114 84.3056C24.512 87.3316 23.0596 65.0601 23.0596 65.0601Z",
    fill: "#FAD300"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 64.9374C23.0596 64.9374 39.279 49.6863 42.3051 56.5856C45.3311 63.606 23.0596 64.9374 23.0596 64.9374Z",
    fill: "#FAD300"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9398 65.0601C22.9398 65.0601 6.72032 80.3112 3.69429 73.4119C0.789306 66.3915 22.9398 65.0601 22.9398 65.0601Z",
    fill: "#FAD300"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 64.9384C23.0596 64.9384 23.7858 42.6668 30.8062 45.4508C37.8265 48.2347 23.0596 64.9384 23.0596 64.9384Z",
    fill: "#FAD300"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0615 65.0601C23.0615 65.0601 22.3352 87.3316 15.3148 84.5476C8.29445 81.7637 23.0615 65.0601 23.0615 65.0601Z",
    fill: "#FAD300"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 65.0601C23.0596 65.0601 45.3311 65.7863 42.5472 72.8067C39.7632 79.706 23.0596 65.0601 23.0596 65.0601Z",
    fill: "#FAD300"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9403 64.9384C22.9403 64.9384 0.668795 64.2121 3.45274 57.1918C6.23669 50.2924 22.9403 64.9384 22.9403 64.9384Z",
    fill: "#FAD300"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4502 64.9399C26.4502 66.7555 24.9977 68.3291 23.0611 68.3291C21.2455 68.3291 19.6719 66.8766 19.6719 64.9399C19.6719 63.1243 21.1244 61.5508 23.0611 61.5508C24.8767 61.5508 26.4502 63.1243 26.4502 64.9399Z",
    fill: "#FAD300"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0609 22.9401C23.0609 22.9401 15.5564 2 23.0609 2C30.5655 2 23.0609 22.9401 23.0609 22.9401Z",
    fill: "#FFE900"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M23.061 23.0601C23.061 23.0601 30.5656 44.0001 23.061 44.0001C15.4354 44.0001 23.061 23.0601 23.061 23.0601Z",
    fill: "#FFE900"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 22.9394C23.0596 22.9394 43.9997 15.4348 43.9997 22.9394C43.9997 30.4439 23.0596 22.9394 23.0596 22.9394Z",
    fill: "#FFE900"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9401 22.9394C22.9401 22.9394 2 30.4439 2 22.9394C2 15.4348 22.9401 22.9394 22.9401 22.9394Z",
    fill: "#FFE900"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 22.9391C23.0596 22.9391 32.5008 2.72525 37.9476 8.05105C43.2734 13.4979 23.0596 22.9391 23.0596 22.9391Z",
    fill: "#FFE900"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0612 23.0601C23.0612 23.0601 13.6199 43.2739 8.17309 37.9481C2.72624 32.6223 23.0612 23.0601 23.0612 23.0601Z",
    fill: "#FFE900"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 23.0601C23.0596 23.0601 43.2734 32.5012 37.9476 37.9481C32.6218 43.1528 23.0596 23.0601 23.0596 23.0601Z",
    fill: "#FFE900"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0612 22.9375C23.0612 22.9375 2.84731 13.4963 8.17312 8.04948C13.4989 2.84472 23.0612 22.9375 23.0612 22.9375Z",
    fill: "#FFE900"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0595 22.9388C23.0595 22.9388 7.80833 6.71929 14.7077 3.69326C21.607 0.667242 23.0595 22.9388 23.0595 22.9388Z",
    fill: "#FAD300"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 23.0601C23.0596 23.0601 38.3107 39.2795 31.4114 42.3056C24.512 45.3316 23.0596 23.0601 23.0596 23.0601Z",
    fill: "#FAD300"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 22.9374C23.0596 22.9374 39.279 7.68627 42.3051 14.5856C45.3311 21.606 23.0596 22.9374 23.0596 22.9374Z",
    fill: "#FAD300"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9398 23.0601C22.9398 23.0601 6.72032 38.3112 3.69429 31.4119C0.789306 24.3915 22.9398 23.0601 22.9398 23.0601Z",
    fill: "#FAD300"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 22.9384C23.0596 22.9384 23.7858 0.666845 30.8062 3.45079C37.8265 6.23473 23.0596 22.9384 23.0596 22.9384Z",
    fill: "#FAD300"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0615 23.0601C23.0615 23.0601 22.3352 45.3316 15.3148 42.5476C8.29445 39.7637 23.0615 23.0601 23.0615 23.0601Z",
    fill: "#FAD300"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 23.0601C23.0596 23.0601 45.3311 23.7863 42.5472 30.8067C39.7632 37.706 23.0596 23.0601 23.0596 23.0601Z",
    fill: "#FAD300"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9403 22.9384C22.9403 22.9384 0.668795 22.2121 3.45274 15.1918C6.23669 8.29243 22.9403 22.9384 22.9403 22.9384Z",
    fill: "#FAD300"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4502 22.9399C26.4502 24.7555 24.9977 26.3291 23.0611 26.3291C21.2455 26.3291 19.6719 24.8766 19.6719 22.9399C19.6719 21.1243 21.1244 19.5508 23.0611 19.5508C24.8767 19.5508 26.4502 21.1243 26.4502 22.9399Z",
    fill: "#FAD300"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0609 442.94C21.0609 442.94 13.5564 422 21.0609 422C28.5655 422 21.0609 442.94 21.0609 442.94Z",
    fill: "#FFE900"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M21.061 443.06C21.061 443.06 28.5656 464 21.061 464C13.4354 464 21.061 443.06 21.061 443.06Z",
    fill: "#FFE900"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 442.939C21.0596 442.939 41.9997 435.435 41.9997 442.939C41.9997 450.444 21.0596 442.939 21.0596 442.939Z",
    fill: "#FFE900"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9401 442.939C20.9401 442.939 0 450.444 0 442.939C0 435.435 20.9401 442.939 20.9401 442.939Z",
    fill: "#FFE900"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 442.939C21.0596 442.939 30.5008 422.725 35.9476 428.051C41.2734 433.498 21.0596 442.939 21.0596 442.939Z",
    fill: "#FFE900"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0612 443.06C21.0612 443.06 11.6199 463.274 6.17309 457.948C0.726244 452.622 21.0612 443.06 21.0612 443.06Z",
    fill: "#FFE900"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 443.06C21.0596 443.06 41.2734 452.501 35.9476 457.948C30.6218 463.153 21.0596 443.06 21.0596 443.06Z",
    fill: "#FFE900"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0612 442.938C21.0612 442.938 0.847308 433.496 6.17312 428.049C11.4989 422.845 21.0612 442.938 21.0612 442.938Z",
    fill: "#FFE900"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0595 442.939C21.0595 442.939 5.80833 426.719 12.7077 423.693C19.607 420.667 21.0595 442.939 21.0595 442.939Z",
    fill: "#FAD300"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 443.06C21.0596 443.06 36.3107 459.28 29.4114 462.306C22.512 465.332 21.0596 443.06 21.0596 443.06Z",
    fill: "#FAD300"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 442.937C21.0596 442.937 37.279 427.686 40.3051 434.586C43.3311 441.606 21.0596 442.937 21.0596 442.937Z",
    fill: "#FAD300"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9398 443.06C20.9398 443.06 4.72032 458.311 1.69429 451.412C-1.21069 444.392 20.9398 443.06 20.9398 443.06Z",
    fill: "#FAD300"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 442.938C21.0596 442.938 21.7858 420.667 28.8062 423.451C35.8265 426.235 21.0596 442.938 21.0596 442.938Z",
    fill: "#FAD300"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0615 443.06C21.0615 443.06 20.3352 465.332 13.3148 462.548C6.29445 459.764 21.0615 443.06 21.0615 443.06Z",
    fill: "#FAD300"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 443.06C21.0596 443.06 43.3311 443.786 40.5472 450.807C37.7632 457.706 21.0596 443.06 21.0596 443.06Z",
    fill: "#FAD300"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9403 442.938C20.9403 442.938 -1.33121 442.212 1.45274 435.192C4.23669 428.292 20.9403 442.938 20.9403 442.938Z",
    fill: "#FAD300"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4502 442.94C24.4502 444.756 22.9977 446.329 21.0611 446.329C19.2455 446.329 17.6719 444.877 17.6719 442.94C17.6719 441.124 19.1244 439.551 21.0611 439.551C22.8767 439.551 24.4502 441.124 24.4502 442.94Z",
    fill: "#FAD300"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0609 106.94C23.0609 106.94 15.5564 86 23.0609 86C30.5655 86 23.0609 106.94 23.0609 106.94Z",
    fill: "#FFE900"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M23.061 107.06C23.061 107.06 30.5656 128 23.061 128C15.4354 128 23.061 107.06 23.061 107.06Z",
    fill: "#FFE900"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 106.939C23.0596 106.939 43.9997 99.4348 43.9997 106.939C43.9997 114.444 23.0596 106.939 23.0596 106.939Z",
    fill: "#FFE900"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9401 106.939C22.9401 106.939 2 114.444 2 106.939C2 99.4348 22.9401 106.939 22.9401 106.939Z",
    fill: "#FFE900"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 106.939C23.0596 106.939 32.5008 86.7252 37.9476 92.051C43.2734 97.4979 23.0596 106.939 23.0596 106.939Z",
    fill: "#FFE900"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0612 107.06C23.0612 107.06 13.6199 127.274 8.17309 121.948C2.72624 116.622 23.0612 107.06 23.0612 107.06Z",
    fill: "#FFE900"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 107.06C23.0596 107.06 43.2734 116.501 37.9476 121.948C32.6218 127.153 23.0596 107.06 23.0596 107.06Z",
    fill: "#FFE900"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0612 106.938C23.0612 106.938 2.84731 97.4963 8.17312 92.0495C13.4989 86.8447 23.0612 106.938 23.0612 106.938Z",
    fill: "#FFE900"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0595 106.939C23.0595 106.939 7.80833 90.7193 14.7077 87.6933C21.607 84.6672 23.0595 106.939 23.0595 106.939Z",
    fill: "#FAD300"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 107.06C23.0596 107.06 38.3107 123.28 31.4114 126.306C24.512 129.332 23.0596 107.06 23.0596 107.06Z",
    fill: "#FAD300"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 106.937C23.0596 106.937 39.279 91.6863 42.3051 98.5856C45.3311 105.606 23.0596 106.937 23.0596 106.937Z",
    fill: "#FAD300"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9398 107.06C22.9398 107.06 6.72032 122.311 3.69429 115.412C0.789306 108.392 22.9398 107.06 22.9398 107.06Z",
    fill: "#FAD300"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 106.938C23.0596 106.938 23.7858 84.6668 30.8062 87.4508C37.8265 90.2347 23.0596 106.938 23.0596 106.938Z",
    fill: "#FAD300"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0615 107.06C23.0615 107.06 22.3352 129.332 15.3148 126.548C8.29445 123.764 23.0615 107.06 23.0615 107.06Z",
    fill: "#FAD300"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 107.06C23.0596 107.06 45.3311 107.786 42.5472 114.807C39.7632 121.706 23.0596 107.06 23.0596 107.06Z",
    fill: "#FAD300"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9403 106.938C22.9403 106.938 0.668795 106.212 3.45274 99.1918C6.23669 92.2924 22.9403 106.938 22.9403 106.938Z",
    fill: "#FAD300"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4502 106.94C26.4502 108.756 24.9977 110.329 23.0611 110.329C21.2455 110.329 19.6719 108.877 19.6719 106.94C19.6719 105.124 21.1244 103.551 23.0611 103.551C24.8767 103.551 26.4502 105.124 26.4502 106.94Z",
    fill: "#FAD300"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0609 484.94C21.0609 484.94 13.5564 464 21.0609 464C28.5655 464 21.0609 484.94 21.0609 484.94Z",
    fill: "#FFE900"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M21.061 485.06C21.061 485.06 28.5656 506 21.061 506C13.4354 506 21.061 485.06 21.061 485.06Z",
    fill: "#FFE900"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 484.939C21.0596 484.939 41.9997 477.435 41.9997 484.939C41.9997 492.444 21.0596 484.939 21.0596 484.939Z",
    fill: "#FFE900"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9401 484.939C20.9401 484.939 0 492.444 0 484.939C0 477.435 20.9401 484.939 20.9401 484.939Z",
    fill: "#FFE900"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 484.939C21.0596 484.939 30.5008 464.725 35.9476 470.051C41.2734 475.498 21.0596 484.939 21.0596 484.939Z",
    fill: "#FFE900"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0612 485.06C21.0612 485.06 11.6199 505.274 6.17309 499.948C0.726244 494.622 21.0612 485.06 21.0612 485.06Z",
    fill: "#FFE900"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 485.06C21.0596 485.06 41.2734 494.501 35.9476 499.948C30.6218 505.153 21.0596 485.06 21.0596 485.06Z",
    fill: "#FFE900"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0612 484.938C21.0612 484.938 0.847308 475.496 6.17312 470.049C11.4989 464.845 21.0612 484.938 21.0612 484.938Z",
    fill: "#FFE900"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0595 484.939C21.0595 484.939 5.80833 468.719 12.7077 465.693C19.607 462.667 21.0595 484.939 21.0595 484.939Z",
    fill: "#FAD300"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 485.06C21.0596 485.06 36.3107 501.28 29.4114 504.306C22.512 507.332 21.0596 485.06 21.0596 485.06Z",
    fill: "#FAD300"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 484.937C21.0596 484.937 37.279 469.686 40.3051 476.586C43.3311 483.606 21.0596 484.937 21.0596 484.937Z",
    fill: "#FAD300"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9398 485.06C20.9398 485.06 4.72032 500.311 1.69429 493.412C-1.21069 486.392 20.9398 485.06 20.9398 485.06Z",
    fill: "#FAD300"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 484.938C21.0596 484.938 21.7858 462.667 28.8062 465.451C35.8265 468.235 21.0596 484.938 21.0596 484.938Z",
    fill: "#FAD300"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0615 485.06C21.0615 485.06 20.3352 507.332 13.3148 504.548C6.29445 501.764 21.0615 485.06 21.0615 485.06Z",
    fill: "#FAD300"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 485.06C21.0596 485.06 43.3311 485.786 40.5472 492.807C37.7632 499.706 21.0596 485.06 21.0596 485.06Z",
    fill: "#FAD300"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9403 484.938C20.9403 484.938 -1.33121 484.212 1.45274 477.192C4.23669 470.292 20.9403 484.938 20.9403 484.938Z",
    fill: "#FAD300"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4502 484.94C24.4502 486.756 22.9977 488.329 21.0611 488.329C19.2455 488.329 17.6719 486.877 17.6719 484.94C17.6719 483.124 19.1244 481.551 21.0611 481.551C22.8767 481.551 24.4502 483.124 24.4502 484.94Z",
    fill: "#FAD300"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0609 315.94C21.0609 315.94 13.5564 295 21.0609 295C28.5655 295 21.0609 315.94 21.0609 315.94Z",
    fill: "#FFE900"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M21.061 316.06C21.061 316.06 28.5656 337 21.061 337C13.4354 337 21.061 316.06 21.061 316.06Z",
    fill: "#FFE900"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 315.939C21.0596 315.939 41.9997 308.435 41.9997 315.939C41.9997 323.444 21.0596 315.939 21.0596 315.939Z",
    fill: "#FFE900"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9401 315.939C20.9401 315.939 0 323.444 0 315.939C0 308.435 20.9401 315.939 20.9401 315.939Z",
    fill: "#FFE900"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 315.939C21.0596 315.939 30.5008 295.725 35.9476 301.051C41.2734 306.498 21.0596 315.939 21.0596 315.939Z",
    fill: "#FFE900"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0612 316.06C21.0612 316.06 11.6199 336.274 6.17309 330.948C0.726244 325.622 21.0612 316.06 21.0612 316.06Z",
    fill: "#FFE900"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 316.06C21.0596 316.06 41.2734 325.501 35.9476 330.948C30.6218 336.153 21.0596 316.06 21.0596 316.06Z",
    fill: "#FFE900"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0612 315.938C21.0612 315.938 0.847308 306.496 6.17312 301.049C11.4989 295.845 21.0612 315.938 21.0612 315.938Z",
    fill: "#FFE900"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0595 315.939C21.0595 315.939 5.80833 299.719 12.7077 296.693C19.607 293.667 21.0595 315.939 21.0595 315.939Z",
    fill: "#FAD300"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 316.06C21.0596 316.06 36.3107 332.28 29.4114 335.306C22.512 338.332 21.0596 316.06 21.0596 316.06Z",
    fill: "#FAD300"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 315.937C21.0596 315.937 37.279 300.686 40.3051 307.586C43.3311 314.606 21.0596 315.937 21.0596 315.937Z",
    fill: "#FAD300"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9398 316.06C20.9398 316.06 4.72032 331.311 1.69429 324.412C-1.21069 317.392 20.9398 316.06 20.9398 316.06Z",
    fill: "#FAD300"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 315.938C21.0596 315.938 21.7858 293.667 28.8062 296.451C35.8265 299.235 21.0596 315.938 21.0596 315.938Z",
    fill: "#FAD300"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0615 316.06C21.0615 316.06 20.3352 338.332 13.3148 335.548C6.29445 332.764 21.0615 316.06 21.0615 316.06Z",
    fill: "#FAD300"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 316.06C21.0596 316.06 43.3311 316.786 40.5472 323.807C37.7632 330.706 21.0596 316.06 21.0596 316.06Z",
    fill: "#FAD300"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9403 315.938C20.9403 315.938 -1.33121 315.212 1.45274 308.192C4.23669 301.292 20.9403 315.938 20.9403 315.938Z",
    fill: "#FAD300"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4502 315.94C24.4502 317.756 22.9977 319.329 21.0611 319.329C19.2455 319.329 17.6719 317.877 17.6719 315.94C17.6719 314.124 19.1244 312.551 21.0611 312.551C22.8767 312.551 24.4502 314.124 24.4502 315.94Z",
    fill: "#FAD300"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0609 149.94C23.0609 149.94 15.5564 129 23.0609 129C30.5655 129 23.0609 149.94 23.0609 149.94Z",
    fill: "#FFE900"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M23.061 150.06C23.061 150.06 30.5656 171 23.061 171C15.4354 171 23.061 150.06 23.061 150.06Z",
    fill: "#FFE900"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 149.939C23.0596 149.939 43.9997 142.435 43.9997 149.939C43.9997 157.444 23.0596 149.939 23.0596 149.939Z",
    fill: "#FFE900"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9401 149.939C22.9401 149.939 2 157.444 2 149.939C2 142.435 22.9401 149.939 22.9401 149.939Z",
    fill: "#FFE900"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 149.939C23.0596 149.939 32.5008 129.725 37.9476 135.051C43.2734 140.498 23.0596 149.939 23.0596 149.939Z",
    fill: "#FFE900"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0612 150.06C23.0612 150.06 13.6199 170.274 8.17309 164.948C2.72624 159.622 23.0612 150.06 23.0612 150.06Z",
    fill: "#FFE900"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 150.06C23.0596 150.06 43.2734 159.501 37.9476 164.948C32.6218 170.153 23.0596 150.06 23.0596 150.06Z",
    fill: "#FFE900"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0612 149.938C23.0612 149.938 2.84731 140.496 8.17312 135.049C13.4989 129.845 23.0612 149.938 23.0612 149.938Z",
    fill: "#FFE900"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0595 149.939C23.0595 149.939 7.80833 133.719 14.7077 130.693C21.607 127.667 23.0595 149.939 23.0595 149.939Z",
    fill: "#FAD300"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 150.06C23.0596 150.06 38.3107 166.28 31.4114 169.306C24.512 172.332 23.0596 150.06 23.0596 150.06Z",
    fill: "#FAD300"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 149.937C23.0596 149.937 39.279 134.686 42.3051 141.586C45.3311 148.606 23.0596 149.937 23.0596 149.937Z",
    fill: "#FAD300"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9398 150.06C22.9398 150.06 6.72032 165.311 3.69429 158.412C0.789306 151.392 22.9398 150.06 22.9398 150.06Z",
    fill: "#FAD300"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 149.938C23.0596 149.938 23.7858 127.667 30.8062 130.451C37.8265 133.235 23.0596 149.938 23.0596 149.938Z",
    fill: "#FAD300"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0615 150.06C23.0615 150.06 22.3352 172.332 15.3148 169.548C8.29445 166.764 23.0615 150.06 23.0615 150.06Z",
    fill: "#FAD300"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0596 150.06C23.0596 150.06 45.3311 150.786 42.5472 157.807C39.7632 164.706 23.0596 150.06 23.0596 150.06Z",
    fill: "#FAD300"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9403 149.938C22.9403 149.938 0.668795 149.212 3.45274 142.192C6.23669 135.292 22.9403 149.938 22.9403 149.938Z",
    fill: "#FAD300"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4502 149.94C26.4502 151.756 24.9977 153.329 23.0611 153.329C21.2455 153.329 19.6719 151.877 19.6719 149.94C19.6719 148.124 21.1244 146.551 23.0611 146.551C24.8767 146.551 26.4502 148.124 26.4502 149.94Z",
    fill: "#FAD300"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0609 357.94C21.0609 357.94 13.5564 337 21.0609 337C28.5655 337 21.0609 357.94 21.0609 357.94Z",
    fill: "#FFE900"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M21.061 358.06C21.061 358.06 28.5656 379 21.061 379C13.4354 379 21.061 358.06 21.061 358.06Z",
    fill: "#FFE900"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 357.939C21.0596 357.939 41.9997 350.435 41.9997 357.939C41.9997 365.444 21.0596 357.939 21.0596 357.939Z",
    fill: "#FFE900"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9401 357.939C20.9401 357.939 0 365.444 0 357.939C0 350.435 20.9401 357.939 20.9401 357.939Z",
    fill: "#FFE900"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 357.939C21.0596 357.939 30.5008 337.725 35.9476 343.051C41.2734 348.498 21.0596 357.939 21.0596 357.939Z",
    fill: "#FFE900"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0612 358.06C21.0612 358.06 11.6199 378.274 6.17309 372.948C0.726244 367.622 21.0612 358.06 21.0612 358.06Z",
    fill: "#FFE900"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 358.06C21.0596 358.06 41.2734 367.501 35.9476 372.948C30.6218 378.153 21.0596 358.06 21.0596 358.06Z",
    fill: "#FFE900"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0612 357.938C21.0612 357.938 0.847308 348.496 6.17312 343.049C11.4989 337.845 21.0612 357.938 21.0612 357.938Z",
    fill: "#FFE900"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0595 357.939C21.0595 357.939 5.80833 341.719 12.7077 338.693C19.607 335.667 21.0595 357.939 21.0595 357.939Z",
    fill: "#FAD300"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 358.06C21.0596 358.06 36.3107 374.28 29.4114 377.306C22.512 380.332 21.0596 358.06 21.0596 358.06Z",
    fill: "#FAD300"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 357.937C21.0596 357.937 37.279 342.686 40.3051 349.586C43.3311 356.606 21.0596 357.937 21.0596 357.937Z",
    fill: "#FAD300"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9398 358.06C20.9398 358.06 4.72032 373.311 1.69429 366.412C-1.21069 359.392 20.9398 358.06 20.9398 358.06Z",
    fill: "#FAD300"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 357.938C21.0596 357.938 21.7858 335.667 28.8062 338.451C35.8265 341.235 21.0596 357.938 21.0596 357.938Z",
    fill: "#FAD300"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0615 358.06C21.0615 358.06 20.3352 380.332 13.3148 377.548C6.29445 374.764 21.0615 358.06 21.0615 358.06Z",
    fill: "#FAD300"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 358.06C21.0596 358.06 43.3311 358.786 40.5472 365.807C37.7632 372.706 21.0596 358.06 21.0596 358.06Z",
    fill: "#FAD300"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9403 357.938C20.9403 357.938 -1.33121 357.212 1.45274 350.192C4.23669 343.292 20.9403 357.938 20.9403 357.938Z",
    fill: "#FAD300"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4502 357.94C24.4502 359.756 22.9977 361.329 21.0611 361.329C19.2455 361.329 17.6719 359.877 17.6719 357.94C17.6719 356.124 19.1244 354.551 21.0611 354.551C22.8767 354.551 24.4502 356.124 24.4502 357.94Z",
    fill: "#FAD300"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0609 273.94C22.0609 273.94 14.5564 253 22.0609 253C29.5655 253 22.0609 273.94 22.0609 273.94Z",
    fill: "#FFE900"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M22.061 274.06C22.061 274.06 29.5656 295 22.061 295C14.4354 295 22.061 274.06 22.061 274.06Z",
    fill: "#FFE900"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0596 273.939C22.0596 273.939 42.9997 266.435 42.9997 273.939C42.9997 281.444 22.0596 273.939 22.0596 273.939Z",
    fill: "#FFE900"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9401 273.939C21.9401 273.939 1 281.444 1 273.939C1 266.435 21.9401 273.939 21.9401 273.939Z",
    fill: "#FFE900"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0596 273.939C22.0596 273.939 31.5008 253.725 36.9476 259.051C42.2734 264.498 22.0596 273.939 22.0596 273.939Z",
    fill: "#FFE900"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0612 274.06C22.0612 274.06 12.6199 294.274 7.17309 288.948C1.72624 283.622 22.0612 274.06 22.0612 274.06Z",
    fill: "#FFE900"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0596 274.06C22.0596 274.06 42.2734 283.501 36.9476 288.948C31.6218 294.153 22.0596 274.06 22.0596 274.06Z",
    fill: "#FFE900"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0612 273.938C22.0612 273.938 1.84731 264.496 7.17312 259.049C12.4989 253.845 22.0612 273.938 22.0612 273.938Z",
    fill: "#FFE900"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0595 273.939C22.0595 273.939 6.80833 257.719 13.7077 254.693C20.607 251.667 22.0595 273.939 22.0595 273.939Z",
    fill: "#FAD300"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0596 274.06C22.0596 274.06 37.3107 290.28 30.4114 293.306C23.512 296.332 22.0596 274.06 22.0596 274.06Z",
    fill: "#FAD300"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0596 273.937C22.0596 273.937 38.279 258.686 41.3051 265.586C44.3311 272.606 22.0596 273.937 22.0596 273.937Z",
    fill: "#FAD300"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9398 274.06C21.9398 274.06 5.72032 289.311 2.69429 282.412C-0.210694 275.392 21.9398 274.06 21.9398 274.06Z",
    fill: "#FAD300"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0596 273.938C22.0596 273.938 22.7858 251.667 29.8062 254.451C36.8265 257.235 22.0596 273.938 22.0596 273.938Z",
    fill: "#FAD300"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0615 274.06C22.0615 274.06 21.3352 296.332 14.3148 293.548C7.29445 290.764 22.0615 274.06 22.0615 274.06Z",
    fill: "#FAD300"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0596 274.06C22.0596 274.06 44.3311 274.786 41.5472 281.807C38.7632 288.706 22.0596 274.06 22.0596 274.06Z",
    fill: "#FAD300"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9403 273.938C21.9403 273.938 -0.331205 273.212 2.45274 266.192C5.23669 259.292 21.9403 273.938 21.9403 273.938Z",
    fill: "#FAD300"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4502 273.94C25.4502 275.756 23.9977 277.329 22.0611 277.329C20.2455 277.329 18.6719 275.877 18.6719 273.94C18.6719 272.124 20.1244 270.551 22.0611 270.551C23.8767 270.551 25.4502 272.124 25.4502 273.94Z",
    fill: "#FAD300"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6 33.2C106.7 33.2 114.2 25.7 114.2 16.6C114.2 7.50001 106.7 0 97.6 0C88.5 0 81 7.50001 81 16.6C81 25.8 88.4 33.2 97.6 33.2Z",
    fill: "#FFE900"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.001 21.9006C104.601 21.9006 108.401 18.1006 108.401 13.5006C108.401 8.90058 104.601 5.10059 100.001 5.10059C95.4006 5.10059 91.6006 8.90058 91.6006 13.5006C91.6006 18.1006 95.4006 21.9006 100.001 21.9006Z",
    fill: "#FAD300"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6 66.2C106.7 66.2 114.2 58.7 114.2 49.6C114.2 40.5 106.7 33 97.6 33C88.5 33 81 40.5 81 49.6C81 58.8 88.4 66.2 97.6 66.2Z",
    fill: "#FFE900"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.001 54.9006C104.601 54.9006 108.401 51.1006 108.401 46.5006C108.401 41.9006 104.601 38.1006 100.001 38.1006C95.4006 38.1006 91.6006 41.9006 91.6006 46.5006C91.6006 51.1006 95.4006 54.9006 100.001 54.9006Z",
    fill: "#FAD300"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6 96.2C106.7 96.2 114.2 88.7 114.2 79.6C114.2 70.5 106.7 63 97.6 63C88.5 63 81 70.5 81 79.6C81 88.8 88.4 96.2 97.6 96.2Z",
    fill: "#FFE900"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.001 84.9006C104.601 84.9006 108.401 81.1006 108.401 76.5006C108.401 71.9006 104.601 68.1006 100.001 68.1006C95.4006 68.1006 91.6006 71.9006 91.6006 76.5006C91.6006 81.1006 95.4006 84.9006 100.001 84.9006Z",
    fill: "#FAD300"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6 129.2C106.7 129.2 114.2 121.7 114.2 112.6C114.2 103.5 106.7 96 97.6 96C88.5 96 81 103.5 81 112.6C81 121.8 88.4 129.2 97.6 129.2Z",
    fill: "#FFE900"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.001 117.901C104.601 117.901 108.401 114.101 108.401 109.501C108.401 104.901 104.601 101.101 100.001 101.101C95.4006 101.101 91.6006 104.901 91.6006 109.501C91.6006 114.101 95.4006 117.901 100.001 117.901Z",
    fill: "#FAD300"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6 159.2C106.7 159.2 114.2 151.7 114.2 142.6C114.2 133.5 106.7 126 97.6 126C88.5 126 81 133.5 81 142.6C81 151.8 88.4 159.2 97.6 159.2Z",
    fill: "#FFE900"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.001 147.901C104.601 147.901 108.401 144.101 108.401 139.501C108.401 134.901 104.601 131.101 100.001 131.101C95.4006 131.101 91.6006 134.901 91.6006 139.501C91.6006 144.101 95.4006 147.901 100.001 147.901Z",
    fill: "#FAD300"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6 193.2C106.7 193.2 114.2 185.7 114.2 176.6C114.2 167.5 106.7 160 97.6 160C88.5 160 81 167.5 81 176.6C81 185.8 88.4 193.2 97.6 193.2Z",
    fill: "#FFE900"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.001 181.901C104.601 181.901 108.401 178.101 108.401 173.501C108.401 168.901 104.601 165.101 100.001 165.101C95.4006 165.101 91.6006 168.901 91.6006 173.501C91.6006 178.101 95.4006 181.901 100.001 181.901Z",
    fill: "#FAD300"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6 223.2C106.7 223.2 114.2 215.7 114.2 206.6C114.2 197.5 106.7 190 97.6 190C88.5 190 81 197.5 81 206.6C81 215.8 88.4 223.2 97.6 223.2Z",
    fill: "#FFE900"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.001 211.901C104.601 211.901 108.401 208.101 108.401 203.501C108.401 198.901 104.601 195.101 100.001 195.101C95.4006 195.101 91.6006 198.901 91.6006 203.501C91.6006 208.101 95.4006 211.901 100.001 211.901Z",
    fill: "#FAD300"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6 256.2C106.7 256.2 114.2 248.7 114.2 239.6C114.2 230.5 106.7 223 97.6 223C88.5 223 81 230.5 81 239.6C81 248.8 88.4 256.2 97.6 256.2Z",
    fill: "#FFE900"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.001 244.901C104.601 244.901 108.401 241.101 108.401 236.501C108.401 231.901 104.601 228.101 100.001 228.101C95.4006 228.101 91.6006 231.901 91.6006 236.501C91.6006 241.101 95.4006 244.901 100.001 244.901Z",
    fill: "#FAD300"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6 286.2C106.7 286.2 114.2 278.7 114.2 269.6C114.2 260.5 106.7 253 97.6 253C88.5 253 81 260.5 81 269.6C81 278.8 88.4 286.2 97.6 286.2Z",
    fill: "#FFE900"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.001 274.901C104.601 274.901 108.401 271.101 108.401 266.501C108.401 261.901 104.601 258.101 100.001 258.101C95.4006 258.101 91.6006 261.901 91.6006 266.501C91.6006 271.101 95.4006 274.901 100.001 274.901Z",
    fill: "#FAD300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopFlower);
export default __webpack_public_path__ + "static/media/top_flower.a2394ec6c69f79d23b69442c6827d570.svg";
export { ForwardRef as ReactComponent };